import { useEffect } from 'react'
import { isHomologHost } from '../lib/isHomologHost'

export function HomologBanner() {
  const show = isHomologHost()

  useEffect(() => {
    if (!show) return
    document.body.classList.add('bp-homolog-active')
    return () => document.body.classList.remove('bp-homolog-active')
  }, [show])

  if (!show) return null

  return (
    <div className="bp-homolog-banner" role="status" aria-live="polite">
      <strong>HOMOLOGAÇÃO</strong> — ambiente de teste · dados separados da produção
    </div>
  )
}
